import {Controller} from '@hotwired/stimulus';

/**
 * Désactive les vignettes d'un sélecteur à vignettes réservées à une offre supérieure.
 *
 *   <div {{ stimulus_controller('plan-restricted-choices') }}>
 *     {{ macros.form_text_image_simple(form.listing_type, form) }}
 *     <template {{ stimulus_target('plan-restricted-choices', 'badge') }}><span class="badge">Pro</span></template>
 *   </div>
 *
 * Le lien de chaque image `img[data-plan-restriction]` du bloc prend la classe `disabled` et reçoit
 * une copie du badge, écrit sur une ligne pour n'y ajouter aucun espace.
 */
export default class extends Controller {
  static targets = ['badge'];

  connect() {
    this.element.querySelectorAll('img[data-plan-restriction]').forEach((image) => {
      const choice = image.parentElement;

      if (choice.classList.contains('disabled')) {
        return;
      }

      choice.append(this.badgeTarget.content.cloneNode(true));
      choice.classList.add('disabled');
    });
  }
}
